"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.basePageTypeFragment = exports.pageFragment = exports.basePageFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.basePageFragment = (0, graphql_tag_1.default) `
  fragment BasePage on Page {
    id
    slug
    pageType {
      id
      name
      slug
    }
  }
`;
exports.pageFragment = (0, graphql_tag_1.default) `
  ${exports.basePageFragment}
  fragment PageDetails on Page {
    ...BasePage
    content
    aboveProductContent
    seoDescription
    seoTitle
    title
    metadata {
      key
      value
    }
  }
`;
exports.basePageTypeFragment = (0, graphql_tag_1.default) `
  fragment BasePageType on PageType {
    id
    slug
  }
`;
//# sourceMappingURL=pages.js.map